import { Collection } from 'modules/core/lib/mobx-rest'

import type Gender from 'modules/settings/store/models/Gender'
import LegalGender from 'modules/settings/store/models/LegalGender'

class LegalGenders extends Collection<LegalGender> {
  get cacheKey(): string {
    return 'legalGenders'
  }

  get indexes() {
    return ['gender_id', 'legal_entity_id']
  }

  model() {
    return LegalGender
  }

  findByGender(gender: Gender): LegalGender[] {
    return this.filter({ gender_id: gender.id })
  }
}

const singleton: LegalGenders = new LegalGenders()

export default singleton
